import * as Yup from 'yup'

export const schemaTransportCompany = (t: (key: string) => string) => ({
  name: Yup.string().required(t('requiredMessage')),
  email: Yup.string()
    .email(t('invalidFormatMessage'))
    .required(t('requiredMessage')),
  phone: Yup.string().required(t('requiredMessage')),
})
